import type { ReactNode } from "react";

interface AdminPageHeaderProps {
    title: string;
    subtitle?: string;
    leftContent?: ReactNode;
    children?: ReactNode;
}

export function AdminPageHeader({
    title,
    subtitle,
    leftContent,
    children,
}: AdminPageHeaderProps) {
    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-start justify-between gap-4">
                <div className="min-w-0 flex-1">
                    <h1 className="text-foreground text-2xl font-semibold tracking-tight">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-muted-foreground mt-1 text-sm">
                            {subtitle}
                        </p>
                    )}
                </div>
                {children && (
                    <div className="flex shrink-0 items-center gap-2">
                        {children}
                    </div>
                )}
            </div>
            {leftContent && <div className="min-w-0">{leftContent}</div>}
        </div>
    );
}
